import { computed, defineComponent, PropType, ref } from 'vue';
import { ActivityAttachment } from '@/store/activityMemo/activityMemo.model';
import BaseOffcanvasComponent from '@/components/baseOffcanvas/BaseOffcanvas.vue';

export default defineComponent({
  name: 'ActivityAttachmentOffcanvasComponent',
  components: {
    BaseOffcanvasComponent,
  },
  props: {
    attachments: {
      type: Object as PropType<ActivityAttachment[]>
    }
  },
  setup: (props) => {
    const attachmentOffcanvas = ref<InstanceType<typeof BaseOffcanvasComponent>>();
    const files = computed<ActivityAttachment[]>(() => (props.attachments) ? props.attachments?.filter(m => m.attachmentType.id === 1) : []);
    const images = computed<ActivityAttachment[]>(() => (props.attachments) ? props.attachments?.filter(m => m.attachmentType.id === 2) : []);

    const show = () => {
      attachmentOffcanvas.value?.show();
    };

    const hide = () => {
      attachmentOffcanvas.value?.hide();
    };

    return {
      files,
      images,
      attachmentOffcanvas,
      show,
      hide,
    };
  },
});
